/**
 * @generated SignedSource<<698e6791df300c73148c4b16684e84f9>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
export type JiraPlanStatus = "ACTIVE" | "ARCHIVED" | "TRASHED" | "%future added value";
import type { FragmentRefs } from "relay-runtime";
export type PlanMenuItemRefactored$data = {
  readonly defaultNavigationItem: {
    readonly url?: string | null | undefined;
  } | null | undefined;
  readonly favouriteValue: {
    readonly isFavourite: boolean | null | undefined;
  } | null | undefined;
  readonly id: string;
  readonly isReadOnly: boolean | null | undefined;
  readonly planId: AGG$Long;
  readonly planStatus: JiraPlanStatus | null | undefined;
  readonly scenario: {
    readonly scenarioId: AGG$Long;
  };
  readonly title: string | null | undefined;
  readonly " $fragmentType": "PlanMenuItemRefactored";
};
export type PlanMenuItemRefactored$key = {
  readonly " $data"?: PlanMenuItemRefactored$data;
  readonly " $fragmentSpreads": FragmentRefs<"PlanMenuItemRefactored">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "PlanMenuItemRefactored",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "id"
    },
    {
      "kind": "RequiredField",
      "field": {
        "kind": "ScalarField",
        "name": "planId"
      },
      "action": "THROW",
      "path": "planId"
    },
    {
      "kind": "ScalarField",
      "name": "title"
    },
    {
      "kind": "ScalarField",
      "name": "isReadOnly"
    },
    {
      "kind": "ScalarField",
      "name": "planStatus"
    },
    {
      "concreteType": "JiraFavouriteValue",
      "kind": "LinkedField",
      "name": "favouriteValue",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "isFavourite"
        }
      ]
    },
    {
      "kind": "RequiredField",
      "field": {
        "concreteType": "JiraScenario",
        "kind": "LinkedField",
        "name": "scenario",
        "plural": false,
        "selections": [
          {
            "kind": "RequiredField",
            "field": {
              "kind": "ScalarField",
              "name": "scenarioId"
            },
            "action": "THROW",
            "path": "scenario.scenarioId"
          }
        ]
      },
      "action": "THROW",
      "path": "scenario"
    },
    {
      "kind": "LinkedField",
      "name": "defaultNavigationItem",
      "plural": false,
      "selections": [
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "kind": "ScalarField",
              "name": "url"
            }
          ],
          "type": "JiraSoftwareBuiltInNavigationItem"
        }
      ]
    }
  ],
  "type": "JiraPlan"
};

(node as any).hash = "e40002e71193568a249dac7dde8d6332";

export default node;
